import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, GiftIcon, MapPinIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-navy-950 overflow-hidden" data-id="element-287">
      {/* Background image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://ntacolleyville.com/wp-content/uploads/sites/611/2023/11/HP-BG-3.jpg)'
    }} data-id="element-288" />
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-navy-950/75" data-id="element-289" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6" data-id="element-290">
        <div className="pt-28 pb-32 md:pt-32 md:pb-36 lg:pt-32 lg:pb-32" data-id="element-291">
          <div className="lg:grid lg:grid-cols-2 lg:gap-12 lg:items-center" data-id="element-292">
            {/* Left Column — Headline & Description */}
            <div data-id="element-293">
              {/* Headline */}
              <motion.h1 className="text-4xl sm:text-5xl lg:text-[3.25rem] xl:text-[3.5rem] font-black leading-[1.08] tracking-tight text-white font-heading" initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5
            }} data-id="element-294">
                Taekwondo &amp; Martial Arts Classes Near{' '}
                <span className="text-amber" data-id="element-295">Colleyville</span>
              </motion.h1>

              {/* Subheadline */}
              <motion.p className="mt-5 text-lg sm:text-xl text-white/75 leading-relaxed max-w-xl" initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.1
            }} data-id="element-296">
                Family-friendly programs for kids, teens and adults at our Hurst
                academy. Build confidence, focus, discipline and self-defense
                skills in a welcoming environment. Ages 3 through adult.
              </motion.p>

              {/* Location helper */}
              <motion.p className="mt-4 flex items-center gap-2 text-sm text-white/50" initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.15
            }} data-id="element-297">
                <MapPinIcon className="w-4 h-4 text-amber/70 shrink-0" data-id="element-298" />
                Located on Grapevine Hwy in Hurst, just minutes from
                Colleyville.
              </motion.p>

              {/* Mobile/Tablet: promo + CTAs stay below headline */}
              <div className="lg:hidden" data-id="element-299">
                {/* Free week offer */}
                <motion.div className="mt-8 flex items-center gap-4 px-6 py-5 bg-amber/10 border border-amber/25 rounded-xl" initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.5,
                delay: 0.2
              }} data-id="element-300">
                  <div className="shrink-0 w-12 h-12 rounded-xl bg-amber/20 flex items-center justify-center" data-id="element-301">
                    <GiftIcon className="w-6 h-6 text-amber" data-id="element-302" />
                  </div>
                  <div data-id="element-303">
                    <p className="text-2xl font-black text-white tracking-tight" data-id="element-304">
                      One Week FREE!
                    </p>
                    <p className="text-sm text-white/50 mt-0.5" data-id="element-305">
                      Try any program — no commitment required
                    </p>
                  </div>
                </motion.div>

                {/* CTAs */}
                <motion.div className="mt-6 flex flex-col sm:flex-row gap-4" initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.5,
                delay: 0.25
              }} data-id="element-306">
                  <a href="#cta" className="inline-flex items-center justify-center gap-2 px-7 py-4 bg-amber text-navy-950 font-bold text-base rounded-lg hover:bg-amber-light transition-colors focus:outline-none focus:ring-2 focus:ring-amber focus:ring-offset-2 focus:ring-offset-navy-950" data-id="element-307">
                    Claim Your Free Week
                    <ArrowRightIcon className="w-4 h-4" data-id="element-308" />
                  </a>
                  <a href="#programs" className="inline-flex items-center justify-center gap-2 px-7 py-4 border-2 border-white/20 text-white font-semibold text-base rounded-lg hover:border-white/40 hover:bg-white/5 transition-colors focus:outline-none focus:ring-2 focus:ring-white/30 focus:ring-offset-2 focus:ring-offset-navy-950" data-id="element-309">
                    Explore Our Programs
                  </a>
                </motion.div>
              </div>
            </div>

            {/* Right Column — Promo (desktop only) */}
            <motion.div className="hidden lg:flex flex-col items-center justify-center" initial={{
            opacity: 0,
            x: 30
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.6,
            delay: 0.15
          }} data-id="element-310">
              {/* Free week offer — LARGE */}
              <div className="w-full max-w-sm bg-amber/10 border border-amber/25 rounded-2xl px-8 py-8 backdrop-blur-sm" data-id="element-311">
                <div className="flex items-center gap-4 mb-4" data-id="element-312">
                  <div className="shrink-0 w-14 h-14 rounded-xl bg-amber/20 flex items-center justify-center" data-id="element-313">
                    <GiftIcon className="w-7 h-7 text-amber" data-id="element-314" />
                  </div>
                  <div data-id="element-315">
                    <p className="text-3xl font-black text-white tracking-tight leading-tight" data-id="element-316">
                      One Week FREE!
                    </p>
                    <p className="text-sm text-white/60 mt-1" data-id="element-317">
                      Try any program — no commitment required
                    </p>
                  </div>
                </div>

                <div className="border-t border-white/10 my-6" data-id="element-318" />

                {/* CTAs stacked */}
                <div className="flex flex-col gap-3" data-id="element-319">
                  <a href="#cta" className="inline-flex items-center justify-center gap-2 px-7 py-4 bg-amber text-navy-950 font-bold text-base rounded-lg hover:bg-amber-light transition-colors focus:outline-none focus:ring-2 focus:ring-amber focus:ring-offset-2 focus:ring-offset-navy-950 w-full" data-id="element-320">
                    Claim Your Free Week
                    <ArrowRightIcon className="w-4 h-4" data-id="element-321" />
                  </a>
                  <a href="#programs" className="inline-flex items-center justify-center gap-2 px-7 py-4 border-2 border-white/20 text-white font-semibold text-base rounded-lg hover:border-white/40 hover:bg-white/5 transition-colors focus:outline-none focus:ring-2 focus:ring-white/30 focus:ring-offset-2 focus:ring-offset-navy-950 w-full" data-id="element-322">
                    Explore Our Programs
                  </a>
                </div>

                {/* Location reassurance */}
                <p className="mt-5 flex items-center justify-center gap-2 text-xs text-white/50" data-id="element-323">
                  <MapPinIcon className="w-3.5 h-3.5 text-amber/60 shrink-0" data-id="element-324" />
                  Located on Grapevine Hwy in Hurst, just minutes from
                  Colleyville.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Bottom edge */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber/20 to-transparent" data-id="element-325" />
    </section>;
}